module.exports = __webpack_public_path__ + "static/decisioningos-pmg-main-desktop-c13259592029a8fdec6c098e96c07312.png";